module.exports = __webpack_public_path__ + "img/component.39f9ace6.svg";